// AI-CONTEXT: See docs/features/update-aanvragen.md

/**
 * @typedef {'denied' | 'failed' | 'loading' | 'empty' | 'ready'} UpdateRequestListState
 */

/**
 * In welke toestand een lijst updateverzoeken verkeert.
 *
 * 'Leeg' is er maar één van vijf. De Firestore-regels weigeren een lees die
 * niet mag, en die weigering levert een LEGE lijst op in plaats van een fout in
 * de data — zonder dit onderscheid staat er 'nog niets aangevraagd' bij een
 * organisatie die wel degelijk verzoeken heeft. Een fout wint daarom van de
 * laadstand: anders blijft er een laadmelding staan die nooit omslaat.
 *
 * Eén plek voor deze afweging, gedeeld door de eigen lijst en het
 * projecttabblad — twee kopieën lopen binnen weken uiteen.
 * AI-CONTEXT: See docs/inbox.md Bug #133
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {object} [result] - Uitkomst van de leeshook
 * @param {Array<object>|string} [result.docs] - De documenten, of '' tijdens het laden
 * @param {{code?: string}|null} [result.error] - Fout van de listener
 * @param {boolean} [result.loading] - Of de hook zelf nog laadt
 * @returns {UpdateRequestListState}
 */
const updateRequestListState = (result) => {
    const { docs, error, loading } = result || {}

    if (error) return error.code === 'permission-denied' ? 'denied' : 'failed'
    if (loading || !Array.isArray(docs)) return 'loading'

    return docs.length === 0 ? 'empty' : 'ready'
}

export default updateRequestListState
